import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const CookiePolicyPage = () => {
  const { theme } = useTheme();
  return (
    <>
      <Helmet><title>Cookie Policy | BookMyAudition</title></Helmet>
      <div className="cookie-policy-page" style={{ minHeight: '70vh', padding: '60px 0', backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc', color: theme === 'dark' ? '#f8fafc' : '#111' }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4">Cookie Policy</h1>
              <p className="mb-5">Understanding how we use cookies to improve your experience.</p>
              <div className="coming-soon-box p-5 rounded-4 shadow-sm" style={{ backgroundColor: theme === 'dark' ? '#111116' : '#fff', border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}` }}>
                <div className="d-inline-block mb-3 px-3 py-1 rounded-pill" style={{ backgroundColor: 'rgba(107, 114, 128, 0.1)', color: '#6b7280', fontSize: '0.85rem', fontWeight: '600' }}>PRIVACY</div>
                <h3>Under Maintenance</h3>
                <p className="text-muted">We are updating our cookie preferences to give you more control over your data.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default CookiePolicyPage;